<script>
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
  },
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  methods: {
    changeEvent(newValue) {
      this.$emit('change', newValue)
    },
  },
}
</script>


<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group slot-scope="{ valid, errors }" v-bind="$attrs">
      <b-input-group>
        <template #prepend>
          <slot name="prepend"> </slot>
        </template>
        <b-form-input
          :class="{
            'bg-light': $attrs.disabled,
          }"
          v-model="innerValue"
          v-bind="$attrs"
          @change="changeEvent"
          :state="errors[0] ? false : innerValue.trim() === '' ? null : valid ? true : null"
        >
        </b-form-input>
        <slot></slot>
      </b-input-group>
      <span class="text-danger">{{ errors[0] }}</span>
      
    </b-form-group>
  </ValidationProvider>
</template>